import apiClient from './api';
import {
  BranchIssueRequestDto,
  CreateBranchIssueRequestDto,
  ApproveRequestDto,
  UpdateBranchIssueRequestDto,
} from '../types/branchIssueRequests.types';

const BASE = '/branchissuerequests';

export const branchIssueRequestsService = {
  async getAll(params?: { branchId?: number; status?: string }): Promise<BranchIssueRequestDto[]> {
    const res = await apiClient.get(BASE, { params });
    return res.data.data || res.data;
  },

  async getById(id: number): Promise<BranchIssueRequestDto> {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data.data || res.data;
  },

  async generateNumber(): Promise<string> {
    const res = await apiClient.get(`${BASE}/generate-number`);
    return (res.data.data || res.data).requestNumber;
  },

  async create(dto: CreateBranchIssueRequestDto): Promise<BranchIssueRequestDto> {
    const res = await apiClient.post(BASE, dto);
    return res.data.data || res.data;
  },

  async update(id: number, dto: UpdateBranchIssueRequestDto): Promise<BranchIssueRequestDto> {
    const res = await apiClient.put(`${BASE}/${id}`, dto);
    return res.data.data || res.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },

  async approve(id: number, dto: ApproveRequestDto): Promise<BranchIssueRequestDto> {
    const res = await apiClient.post(`${BASE}/${id}/approve`, dto);
    return res.data.data || res.data;
  },

  async reject(id: number, reason?: string): Promise<BranchIssueRequestDto> {
    const res = await apiClient.post(`${BASE}/${id}/reject`, { reason });
    return res.data.data || res.data;
  },
};
